import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Resource } from '../shared/models/resource';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<Resource[]>>{
    return this.http.get<IApiResult<Resource[]>>(`${this.apiUrlProvider.url}/resource`);
  }

  add(entity: Resource): Observable<IApiResult<Resource>>{
    return this.http.post<IApiResult<Resource>>(`${this.apiUrlProvider.url}/resource`, entity);
  }

  update(entity: Resource): Observable<IApiResult<Resource>>{
    return this.http.post<IApiResult<Resource>>(`${this.apiUrlProvider.url}/resource/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/resource/${entityId}/delete`, null);
  }
}
